import { env } from '@/env'

interface ClarityFn {
  (...args: unknown[]): void
  q?: unknown[]
}

declare global {
  interface Window {
    clarity?: ClarityFn
  }
}

const PROJECT_ID = env.VITE_CLARITY_PROJECT_ID

// Só dispara no build de produção e com o ID configurado — assim dev/staging não
// poluem os dados de analytics comportamental.
const enabled = import.meta.env.PROD && !!PROJECT_ID

// Reimplementação tipada do snippet base do Microsoft Clarity: cria o clarity que
// enfileira chamadas até o tag.js carregar, e injeta o script.
export function initClarity(): void {
  if (!enabled || window.clarity) return

  const clarity: ClarityFn = (...args: unknown[]) => {
    ;(clarity.q ??= []).push(args)
  }
  window.clarity = clarity

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.clarity.ms/tag/${PROJECT_ID}`
  document.head.appendChild(script)
}
